window.$ = window.jQuery = require('jquery');

require('bootstrap/dist/css/bootstrap.min.css');
const bootstrap = require('bootstrap');
window.bootstrap = bootstrap;
